export default __webpack_public_path__ + "static/media/hoverBin.85001674.wav";